import { Reveal, Eyebrow } from "./Reveal";

export default function Shloka() {
  return (
    <section id="wisdom" data-testid="wisdom-section" className="bg-cream py-24 lg:py-36">
      <div className="max-w-[1440px] mx-auto px-6 md:px-12">
        <div className="max-w-4xl mx-auto">
          <Reveal className="text-center">
            <Eyebrow>03 — Ayurvedic Wisdom</Eyebrow>
          </Reveal>

          <Reveal delay={0.1}>
            <div className="relative mt-10 rounded-3xl bg-parchment border border-sand px-6 py-14 md:px-16 md:py-20">
              {["top-4 left-4", "top-4 right-4", "bottom-4 left-4", "bottom-4 right-4"].map((pos) => (
                <span key={pos} className={`absolute ${pos} h-3 w-3 border border-gold rotate-45`} />
              ))}

              <p
                data-testid="shloka-devanagari"
                lang="sa"
                className="font-devanagari text-center text-[1.45rem] md:text-4xl leading-[2] text-pine"
              >
                दिनान्ते च पिबेद् दुग्धं रात्र्यान्ते च पिबेज्जलम्।
                <br />
                भोजनान्ते पिबेच्छाक्रं किं वैद्यस्य प्रयोजनम्॥
              </p>

              <p className="mt-8 text-center font-mono text-[10px] md:text-xs uppercase tracking-[0.25em] text-sage">
                Dinānte ca pibed dugdhaṁ · rātryānte ca pibejjalam · bhojanānte pibecchākram
              </p>
            </div>
          </Reveal>

          <Reveal delay={0.2}>
            <p className="mt-12 text-center font-serif italic text-xl md:text-3xl leading-relaxed text-coal">
              “Drink milk at the end of the day — it helps you sleep well. Drink water at the end
              of the night — it cleanses your system. Drink buttermilk at the end of your meal —
              it aids digestion. If one does this, why would one need a physician?”
            </p>
            <p className="mt-8 text-center font-mono text-[10px] md:text-[11px] uppercase tracking-[0.3em] text-gold">
              As they say — an apple a day keeps the doctor away.
            </p>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
